(function(){
/* Bilder, Beispiele und Endpoint liefert die Section als GGC_CFG */
const A  = GGC_CFG.images;   // Produktbilder
const EX = GGC_CFG.ex;       // Kundenumsetzungen aus Inhalt -> Dateien

/* ============================================================================
   PREISE – Stand: Preislisten "GORILLA GARDENING 2025"
   ----------------------------------------------------------------------------
   Alle Preise sind PRO STÜCK und INKL. MWST.

   addUnit        : Aufschlag pro Stueck in CHF. Beispiele: Couvert +0.80,
                    DTF-Druck statt Siebdruck +0.50, Falz +0.50.
   surcharge      : einmaliger Aufpreis pro Auftrag (individuelle
                    Erklaerungskarte CHF 50). Kommt EINMAL aufs Total.
   showIf         : blendet Gruppe oder Wahl abhaengig von einer anderen
                    Wahl ein. Beispiel: Falz gibt es nur bei A5 und A4.
   preview        : Bild, das der Knopf "Vorschau" gross anzeigt.
   custom         : Produkt ohne Preisliste – fuehrt direkt ins Formular.

   ZUM AKTUALISIEREN: nur die Zahlen in "prices" anpassen. Sonst nichts.
   ========================================================================== */

const PRICING = {

  "seedballs-beutel": {
    name:"Seedballs im Baumwollbeutel",
    desc:"Fünf handgemachte Samenkugeln im bedruckten Baumwollbeutel",
    img: A["seedballs-beutel"],
    priceKey:[],
    prices:{
      "":[{from:50,price:15.00},{from:100,price:12.00},{from:250,price:9.50},
          {from:500,price:8.50},{from:1000,price:7.50}]
    },
    examples:[
      {img:EX["beutel-pronatura.jpg"], title:"Pro Natura",
       text:"Siebdruck einfarbig grün — Give-away für Mitglieder."},
      {img:EX["beutel-nyon.jpg"], title:"Balades Nature en Ville, Nyon",
       text:"Zweifarbiger Druck für eine städtische Naturkampagne."},
      {img:EX["beutel-wattdor.jpg"], title:"Watt d'Or",
       text:"Kräftiges Rot auf naturbelassener Baumwolle — Preisverleihung des Bundes."},
      {img:EX["beutel-frey.jpg"], title:"Frey und Frey Architekten",
       text:"Detailreiche Illustration in Schwarz — Siebdruck auf Naturbaumwolle."},
      {img:EX["beutel-hochzeit.jpg"], title:"Hochzeit",
       text:"Blumenkranz mit Namen und Datum in Rot — als Gastgeschenk am Platz."}
    ],
    specs:`<strong>Beutel</strong> — 15 cm hoch, 7 cm breit · 5 Seedballs<br>
           <strong>Druck</strong> — Siebdruck einfarbig oder DTF-Druck mehrfarbig<br>
           Eine Erklärungskarte liegt jedem Beutel bei.`,
    options:[
      {id:"sorte",label:"Saatgut",type:"radio",choices:[
        {v:"wild",  label:"Wildblumen", default:true},
        {v:"mohn",  label:"Mohn"},
        {v:"sonne", label:"Sonnenblumen"},
        {v:"kraut", label:"Kräuter"},
        {v:"salat", label:"Salatblumen"},
        {v:"bienen",label:"Bienen"}
      ]},
      {id:"druck",label:"Druck",type:"radio",choices:[
        {v:"sieb", label:"Siebdruck, einfarbig", default:true},
        {v:"dtf",  label:"DTF-Druck, mehrfarbig", addUnit:0.50}
      ]},
      {id:"karte",label:"Erklärungskarte",
       hint:"Eine eigene Gestaltung verrechnen wir pauschal, unabhängig von der Auflage.",
       preview: A["karte-beutel"],
       previewCaption:"Unsere Erklärungskarte, wie sie jedem Baumwollbeutel beiliegt.",
       type:"radio",choices:[
        {v:"gg", label:"Erklärungskarte in unserem Design", default:true},
        {v:"ind",label:"Erklärungskarte individuell", surcharge:50}
      ]}
    ]
  },

  "seedballs-box": {
    name:"Seedballs einzeln",
    desc:"Ein Seedball in der bedruckten Sechskantbox mit Holzwolle",
    img: A["seedballs-box"],
    priceKey:[],
    prices:{
      "":[{from:50,price:7.00},{from:100,price:6.00},{from:250,price:5.00},
          {from:500,price:4.20},{from:1000,price:3.50}]
    },
    examples:[
      {img:EX["box-zaemewachse.jpg"], title:"Zäme wachse",
       text:"Handlettering auf Salbeigrün — Eisenbahner-Baugenossenschaft Bern."},
      {img:EX["box-holliger.jpg"], title:"Holliger",
       text:"Florale Illustration in Kupfer auf Graspapier."},
      {img:EX["box-huserschnell.jpg"], title:"Huser Schnell Architekten",
       text:"Grafisches Farbverlaufsmuster mit den beiden Standorten."},
      {img:EX["box-spreadthelove.jpg"], title:"Spread the Love",
       text:"Illustrierte Anleitung rundum — die Box erzählt die ganze Geschichte."},
      {img:EX["box-danke.jpg"], title:"Danke",
       text:"Kräftiges Blau mit Cut-out-Typografie — als Dankeschön nach dem Event."}
    ],
    specs:`<strong>Box</strong> — 7 cm hoch, 4.5 cm breit · 1 Seedball mit Holzwolle<br>
           <strong>Druck</strong> — mehrfarbig, freie Gestaltung auf Stanzvorlage<br>
           Eine Erklärungskarte liegt jeder Box bei.`,
    options:[
      {id:"sorte",label:"Saatgut",type:"radio",choices:[
        {v:"wild",  label:"Wildblumen", default:true},
        {v:"mohn",  label:"Mohn"},
        {v:"sonne", label:"Sonnenblumen"},
        {v:"kraut", label:"Kräuter"},
        {v:"salat", label:"Salatblumen"},
        {v:"bienen",label:"Bienen"}
      ]},
      {id:"karte",label:"Erklärungskarte",
       hint:"Eine eigene Gestaltung verrechnen wir pauschal, unabhängig von der Auflage.",
       preview: A["karte-box"],
       previewCaption:"Unsere Erklärungskarte, wie sie jeder Sechskantbox beiliegt.",
       type:"radio",choices:[
        {v:"gg", label:"Erklärungskarte in unserem Design", default:true},
        {v:"ind",label:"Erklärungskarte individuell", surcharge:50}
      ]}
    ]
  },

  seedpaper: {
    name:"Seedpaper",
    desc:"Handgeschöpftes Samenpapier – einpflanzbar statt entsorgbar",
    img: A["seedpaper"],
    priceKey:["format","druck"],
    prices:{
      "a6|1s":[{from:50,price:2.90},{from:100,price:2.40},{from:250,price:1.90},
               {from:500,price:1.50},{from:750,price:1.30},{from:1000,price:1.10}],
      "a6|2s":[{from:50,price:3.70},{from:100,price:3.00},{from:250,price:2.40},
               {from:500,price:1.80},{from:750,price:1.60},{from:1000,price:1.40}],
      "a5|1s":[{from:50,price:4.30},{from:100,price:3.60},{from:250,price:2.80},
               {from:500,price:2.20},{from:750,price:1.90},{from:1000,price:1.60}],
      "a5|2s":[{from:50,price:5.40},{from:100,price:4.50},{from:250,price:3.50},
               {from:500,price:2.70},{from:750,price:2.30},{from:1000,price:2.10}],
      "a4|1s":[{from:50,price:7.50},{from:100,price:6.20},{from:250,price:4.90},
               {from:500,price:3.70},{from:750,price:3.20},{from:1000,price:2.80}],
      "a4|2s":[{from:50,price:9.40},{from:100,price:7.80},{from:250,price:6.10},
               {from:500,price:4.70},{from:750,price:4.00},{from:1000,price:3.50}]
    },
    examples:[
      {img:EX["seedpaper-ricola.jpg"], title:"Ricola",
       text:"A6-Karte, einseitig bedruckt mit floraler Rahmen-Illustration."},
      {img:EX["seedpaper-lienert.jpg"], title:"Jörg Lienert",
       text:"Zweifarbig, feine Strichzeichnungen — Weihnachtskarte «Zauber der Natur»."},
      {img:EX["seedpaper-vergissmeinnicht.jpg"], title:"Medusahair",
       text:"Botanische Illustration in Vollfarbe zum 20-Jahr-Jubiläum."},
      {img:EX["seedpaper-vergraben.jpg"], title:"Berufsbildung",
       text:"Querformat, reine Typografie — die Botschaft steht im Mittelpunkt."},
      {img:EX["seedpaper-klappkarte.jpg"], title:"Klappkarte",
       text:"Gefalzt und innen bedruckt — Hochzeitseinladung Noemi & Zakaria."},
      {img:EX["seedpaper-couvert.jpg"], title:"Mit Couvert",
       text:"Dieselbe Klappkarte mit passendem Couvert aus Recyclingpapier."},
      {img:EX["seedpaper-tandem.jpg"], title:"Illustration",
       text:"Feine Strichzeichnung, einfarbig auf handgeschöpftem Samenpapier."}
    ],
    specs:`<strong>Grafikvorgaben</strong> — Die Druckfläche sollte maximal 40 % der Karte
           abdecken; bei grösseren Flächen kann die Keimgarantie beeinträchtigt sein.
           Randabfallender Druck ist nicht möglich, es braucht mindestens 2 cm Rand.`,
    options:[
      {id:"format",label:"Format",type:"radio",choices:[
        {v:"a6",label:"A6 Postkarte", img:A["seedpaper"], default:true},
        {v:"a5",label:"A5 Karte",     img:A["seedpaper"]},
        {v:"a4",label:"A4 Bogen",     img:A["seedpaper"]}
      ]},
      {id:"druck",label:"Druck",type:"radio",choices:[
        {v:"1s",label:"Einseitig", default:true},
        {v:"2s",label:"Doppelseitig"}
      ]},
      /* Gefalzt wird immer auf das naechstkleinere Format. Bei A6 gibt es
         nichts zu falzen, deshalb erscheint die ganze Gruppe dort nicht.
         Der Aufpreis ist in jedem Fall derselbe. */
      {id:"falz",label:"Falz",type:"radio",
       showIf:{format:["a5","a4"]},
       choices:[
        {v:"ohne", label:"Ohne Falz", default:true},
        {v:"auf-a5", label:"Gefalzt auf A5", addUnit:0.50, showIf:{format:["a4"]}},
        {v:"auf-a6", label:"Gefalzt auf A6", addUnit:0.50, showIf:{format:["a5"]}}
      ]},
      {id:"couvert",label:"Couvert",type:"radio",choices:[
        {v:"ohne",  label:"Ohne Couvert",                        default:true},
        {v:"weiss", label:"Mit Couvert, weiss",                  addUnit:0.80},
        {v:"recy",  label:"Mit Couvert, Recyclingpapier braun",  addUnit:0.80}
      ]},
      {id:"extras",label:"Zusätzlich",hint:"Aufpreis gemäss Offerte.",type:"check",choices:[
        {v:"grafik", label:"Gestaltung durch uns"}
      ]}
    ]
  },

  seedpills: {
    name:"Seedpills",
    desc:"Samenpillen in der Tüte – kompakt, leicht, ideal als Beileger",
    img: A["seedpills"],
    priceKey:["inhalt"],
    prices:{
      "3":[{from:100,price:4.20},{from:250,price:3.70},{from:500,price:3.20},{from:1000,price:2.70}],
      "5":[{from:100,price:5.00},{from:250,price:4.50},{from:500,price:4.00},{from:1000,price:3.50}]
    },
    examples:[
      {img:EX["seedpills-fhnw.jpg"], title:"FHNW — Bau die Zukunft",
       text:"Bedruckte Lasche mit QR-Code, mehrfarbig auf gestrichenem Papier."},
      {img:EX["seedpills-vergissmeinnicht.jpg"], title:"Vergissmeinnicht",
       text:"Handlettering schwarz auf Kraftpapier — als Dankeschön nach dem Fest."},
      {img:EX["seedpills-rethink.jpg"], title:"Rethink Resource",
       text:"Firmenlogo und Saatgutname auf weisser Lasche, klar und reduziert."},
      {img:EX["seedpills-deinfest.jpg"], title:"Dein Fest. Bei uns.",
       text:"Art-déco-Ornament in Gold und Grün — Give-away einer Eventlocation."}
    ],
    specs:`Seedpills werden ca. einen Zentimeter unter die Erde gedrückt, gegossen —
           und wachsen los. Die Tüte wird mit deinem Motiv bedruckt.`,
    options:[
      {id:"inhalt",label:"Inhalt pro Tüte",type:"radio",choices:[
        {v:"5",label:"5 Pillen pro Tüte", img:A["seedpills"], default:true},
        {v:"3",label:"3 Pillen pro Tüte", img:A["seedpills"]}
      ]},
      {id:"sorte",label:"Saatgut",type:"radio",choices:[
        {v:"vergiss",label:"Vergissmeinnicht", default:true},
        {v:"mohn",   label:"Mohn"},
        {v:"melisse",label:"Zitronenmelisse"},
        {v:"wild",   label:"Wildblumen"}
      ]}
    ]
  },

  samentueten: {
    name:"Samentüten",
    desc:"Pergamintüte mit individuell gestalteter Lasche",
    img: A["samentueten"],
    priceKey:[],
    prices:{
      "":[{from:50,price:6.00},{from:100,price:4.50},{from:250,price:3.50},
          {from:500,price:3.20},{from:1000,price:2.50}]
    },
    examples:[
      {img:EX["samentueten-mobiliere.jpg"], title:"la Mobilière",
       text:"Vollflächig rote Lasche mit Text — Beileger zur Arbeitgeberkampagne."},
      {img:EX["samentueten-danke.jpg"], title:"Gemeinsam wachsen wir",
       text:"Schwarz-Weiss plus Gelb auf ungestrichenem Papier — als Dankeschön."}
    ],
    specs:`<strong>Masse</strong> — 7,7 × 10,5 cm · hochwertige Pergamintüte mit angepasster Lasche<br>
           <strong>Saatgut</strong> — Wildblumen, Sonnenblumen, Wildkräuter, Salatblumen und Mohn;
           auf Wunsch auch Gemüse- oder andere Kräutersamen<br>
           Wir arbeiten mit einer Schweizer Bio-Sämerei zusammen.`,
    options:[
      {id:"sorte",label:"Saatgut",type:"radio",choices:[
        {v:"wild",  label:"Wildblumen", default:true},
        {v:"sonne", label:"Sonnenblumen"},
        {v:"kraut", label:"Wildkräuter"},
        {v:"salat", label:"Salatblumen"},
        {v:"mohn",  label:"Mohn"},
        {v:"andere",label:"Gemüse / andere Kräuter (auf Anfrage)"}
      ]},
      {id:"druck",label:"Druck auf der Lasche",type:"radio",choices:[
        {v:"gestrichen",  label:"Mehrfarbig, gestrichenes Papier", default:true},
        {v:"ungestrichen",label:"Mehrfarbig, ungestrichenes Papier"},
        {v:"kraft",       label:"Schwarz-Weiss auf Kraftpapier"}
      ]}
    ]
  },

  /* Kein Listenprodukt: keine Preistabelle, kein Kalkulator. Der Klick fuehrt
     direkt ins Offertformular. */
  idee: {
    name:"Deine eigene Idee",
    desc:"Etwas anderes im Sinn? Erzähl es uns – wir finden eine Lösung",
    img: A["idee"],
    custom:true,
    priceKey:[], prices:{}, options:[], examples:[],
    specs:`Wir produzieren fast alles im eigenen Haus in Wabern. Deshalb sind auch
           Sonderwünsche möglich: andere Formate, andere Verpackungen, spezielles
           Saatgut oder eine ganz eigene Idee.<br>
           Beschreib uns, was dir vorschwebt — Anlass, ungefähre Menge und Budget
           genügen für den Anfang. Wir melden uns mit einem Vorschlag.`
  }
};

const FORMSPREE_ENDPOINT = GGC_CFG.endpoint;

/* ========================================================================== */

const CHF = n => "CHF " + n.toLocaleString("de-CH",{minimumFractionDigits:2,maximumFractionDigits:2});
const NUM = n => n.toLocaleString("de-CH");
const $   = id => document.getElementById(id);

const PH_STANDARD = "Farbwünsche, Text auf der Erklärungskarte, spezielles Saatgut …";
const PH_IDEE     = "Beschreib uns deine Idee — Produkt, Anlass, ungefähre Menge und Budget …";

let state = { product:null, choices:{} };

function visible(o){
  if(!o.showIf) return true;
  return Object.entries(o.showIf).every(([k,v])=>v.includes(state.choices[k]));
}
function visibleChoices(o){
  return o.choices.filter(c=>!c.showIf ||
    Object.entries(c.showIf).every(([k,v])=>v.includes(state.choices[k])));
}

/* ---------------- Produktwahl ---------------- */
function renderProducts(){
  $("products").innerHTML = Object.entries(PRICING).map(([key,p])=>{
    const alle  = Object.values(p.prices).flat().map(t=>t.price);
    const preis = p.custom ? "Preis nach Absprache"
                           : `ab ${CHF(Math.min(...alle))} pro Stück`;
    const aktionen = p.custom
      ? `<button class="pact" type="button" data-act="info" data-key="${key}">Infos</button>
         <button class="pact calc" type="button" data-act="calc"
                 data-key="${key}">Anfrage senden</button>`
      : `<button class="pact" type="button" data-act="info"  data-key="${key}">Infos</button>
         <button class="pact" type="button" data-act="bsp"   data-key="${key}">Beispiele</button>
         <button class="pact calc" type="button" data-act="calc" data-key="${key}">Kalkulator</button>`;

    return `<div class="pcard${p.custom ? " idea" : ""}" data-key="${key}" aria-pressed="false">
      <button class="frame" type="button" data-act="calc" data-key="${key}"
              aria-label="${p.custom ? p.name + " – Anfrage senden" : p.name + " konfigurieren"}">
        <img src="${p.img}" alt="${p.name}" loading="lazy">
        <span class="tick" aria-hidden="true">&#10003;</span>
      </button>
      <span class="name">${p.name}</span>
      <span class="from">${preis}</span>
      <div class="pacts">${aktionen}</div>
    </div>`;
  }).join("");

  document.querySelectorAll(".ggc .pcard .frame, .ggc .pcard .pact").forEach(b=>
    b.addEventListener("click", ()=>{
      const {act, key} = b.dataset;
      if(act === "calc") selectProduct(key);
      else openModal(key, act);
    }));
}

/* ---------------- Fenster fuer Infos und Beispiele ----------------
   Oeffnet mittig ueber der Seite. Schliesst per Knopf, Klick auf den
   Hintergrund oder Escape. Der Knopf im Fuss fuehrt direkt in den
   Kalkulator, damit der Weg vom Anschauen zum Rechnen kurz bleibt. */
const gmodal = $("gmodal");

function openModal(key, act){
  const p = PRICING[key];
  let inhalt;

  if(act === "info"){
    let preistext = "";
    if(!p.custom){
      const alle  = Object.values(p.prices).flat().map(t=>t.price);
      const tiers = Object.values(p.prices)[0];
      preistext = `<p>Staffelpreise ab ${NUM(tiers[0].from)} Stück, ab ${CHF(Math.min(...alle))} pro Stück.
         Über ${NUM(tiers[tiers.length-1].from)} Stück offerieren wir individuell.
         Alle Preise inkl. MwSt.</p>`;
    }
    inhalt = `<div class="dtext"><p>${p.desc}.</p>${p.specs || ""}${preistext}</div>`;
  } else {
    const ex = (p.examples || []).filter(e => e.img);
    inhalt = ex.length
      ? `<div class="exgrid">` + ex.map(e=>`
          <div class="excard">
            <span class="exframe"><img src="${e.img}" alt="${e.title}" loading="lazy"></span>
            <span class="extitle">${e.title}</span>
            <span class="extext">${e.text}</span>
          </div>`).join("") + `</div>`
      : `<div class="dtext"><p>Für dieses Produkt sind noch keine Beispiele hinterlegt.</p></div>`;
  }

  $("gmTitle").textContent = p.name + " — " + (act === "info" ? "Infos" : "Beispiele");
  $("gmBody").innerHTML = inhalt;
  $("gmBody").scrollTop = 0;

  const cta = $("gmCta");
  cta.textContent = p.custom ? "Anfrage senden" : p.name + " konfigurieren";
  cta.onclick = ()=>{ closeModal(); selectProduct(key); };

  gmodal.classList.add("on");
  gmodal.setAttribute("aria-hidden", "false");
  sperreHintergrund();
  $("gmClose").focus();
}

function closeModal(){
  if(!gmodal.classList.contains("on")) return;
  gmodal.classList.remove("on");
  gmodal.setAttribute("aria-hidden", "true");
  $("gmBody").innerHTML = "";
  gibHintergrundFrei();
}

$("gmClose").addEventListener("click", closeModal);
gmodal.addEventListener("click", e => { if(e.target === gmodal) closeModal(); });

/* Hintergrund festhalten, solange ein Fenster offen ist. Die Breite der
   Bildlaufleiste wird ausgeglichen, sonst springt das Layout beim Oeffnen. */
function sperreHintergrund(){
  const breite = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.overflow = "hidden";
  if(breite > 0) document.body.style.paddingRight = breite + "px";
}
function gibHintergrundFrei(){
  /* Erst freigeben, wenn wirklich kein Fenster mehr offen ist. */
  if(gmodal.classList.contains("on") || lb.classList.contains("on")) return;
  document.documentElement.style.overflow = "";
  document.body.style.paddingRight = "";
}

function selectProduct(key, scroll=true){
  state.product = key;
  const p = PRICING[key];
  document.querySelectorAll(".ggc .pcard").forEach(el=>
    el.setAttribute("aria-pressed", el.dataset.key===key?"true":"false"));

  const area = $("configArea");
  area.classList.add("shown");
  requestAnimationFrame(()=>area.classList.add("visible"));

  /* Eigene Idee: Es gibt nichts zu rechnen. Schritt 1 und 2 samt Preistafel
     bleiben ausgeblendet, der Kunde landet direkt im Offertformular. */
  if(p.custom){
    area.classList.add("only-form");
    $("mobilebar").classList.remove("on");
    state.choices = {};
    $("bemerkung").placeholder = PH_IDEE;
    recalc();
    setTimeout(()=>$("offerteSection").scrollIntoView({behavior:"smooth", block:"start"}), 90);
    return;
  }

  area.classList.remove("only-form");
  $("bemerkung").placeholder = PH_STANDARD;

  state.choices = {};
  p.options.forEach(o=>{
    state.choices[o.id] = o.type==="radio"
      ? (o.choices.find(c=>c.default) || o.choices[0]).v : [];
  });
  normaliseChoices();

  $("qty").value = table()[0].from;
  $("cfgSub").textContent = p.desc + ".";
  $("specs").innerHTML = p.specs || "";
  $("specs").style.display = p.specs ? "" : "none";

  renderOptions(); renderTierChips(); recalc();
  $("mobilebar").classList.add("on");

  /* Bei JEDER Produktwahl zum Kalkulator scrollen, nicht nur beim ersten Mal.
     Der Schalter "Auswahl zuruecksetzen" ruft mit scroll=false auf und bleibt
     deshalb an Ort und Stelle. */
  if(scroll){
    setTimeout(()=>area.scrollIntoView({behavior:"smooth", block:"start"}), 90);
  }
}

/* Wechselt der Kunde das Format, passen manche Wahlmoeglichkeiten nicht mehr
   – etwa "Gefalzt auf A5", wenn er von A4 auf A6 wechselt. Dann faellt die
   Gruppe auf ihre Vorgabe zurueck, statt eine unmoegliche Wahl zu behalten. */
function normaliseChoices(){
  const p = PRICING[state.product];
  p.options.forEach(o=>{
    if(o.type!=="radio" || !visible(o)) return;
    const vc = visibleChoices(o);
    if(vc.length && !vc.some(c=>c.v===state.choices[o.id]))
      state.choices[o.id] = (vc.find(c=>c.default) || vc[0]).v;
  });
}

/* ---------------- Optionen ---------------- */
function renderOptions(){
  const p = PRICING[state.product];
  $("options").innerHTML = p.options.filter(visible).map(o=>{
    const chips = visibleChoices(o).map(c=>{
      const on = o.type==="radio"
        ? state.choices[o.id]===c.v : state.choices[o.id].includes(c.v);
      const delta = c.addUnit   ? `+${CHF(c.addUnit)} / Stk`
                  : c.surcharge ? `+${CHF(c.surcharge)} einmalig` : "";
      return `<span class="choice" data-on="${on?1:0}" data-opt="${o.id}" data-val="${c.v}"
                    role="button" tabindex="0">${c.label}${
                delta?`<span class="delta">${delta}</span>`:""}</span>`;
    }).join("");

    /* Der Vorschau-Knopf erscheint nur, wenn im Theme-Editor auch wirklich
       ein Bild hinterlegt ist – sonst zeigte er auf ein leeres Fenster. */
    const vorschau = o.preview
      ? `<button class="prevbtn" type="button" data-prev="${o.id}">Vorschau</button>` : "";
    return `<div class="optgroup">
      <div class="title-row"><span class="title">${o.label}</span>${vorschau}</div>
      ${o.hint?`<div class="hint">${o.hint}</div>`:""}
      <div class="choices">${chips}</div></div>`;
  }).join("");

  document.querySelectorAll(".ggc .prevbtn").forEach(b=>
    b.addEventListener("click", ()=>{
      const o = PRICING[state.product].options.find(x=>x.id===b.dataset.prev);
      if(o && o.preview) openLightbox(o.preview, o.previewCaption, o.label);
    }));

  document.querySelectorAll(".ggc .choice").forEach(el=>{
    const pick = ()=>{
      const optId = el.dataset.opt, val = el.dataset.val;
      const o = PRICING[state.product].options.find(x=>x.id===optId);
      if(o.type==="radio") state.choices[optId] = val;
      else { const a=state.choices[optId], i=a.indexOf(val); i>-1?a.splice(i,1):a.push(val); }
      normaliseChoices(); renderOptions(); renderTierChips(); recalc();
    };
    el.addEventListener("click", pick);
    el.addEventListener("keydown", e=>{
      if(e.key==="Enter"||e.key===" "){ e.preventDefault(); pick(); }
    });
  });
}

/* ---------------- Bildfenster ---------------- */
const lb = $("lightbox");

function openLightbox(src, caption, label){
  const img = $("lbImg"), cap = $("lbCap");
  img.src = src;
  img.alt = label ? label + " – Vorschau" : "Vorschau";
  cap.textContent = caption || "";
  cap.style.display = caption ? "" : "none";
  lb.classList.add("on");
  lb.setAttribute("aria-hidden", "false");
  sperreHintergrund();
  $("lbClose").focus();
}

function closeLightbox(){
  if(!lb.classList.contains("on")) return;
  lb.classList.remove("on");
  lb.setAttribute("aria-hidden", "true");
  $("lbImg").removeAttribute("src");
  gibHintergrundFrei();
}

$("lbClose").addEventListener("click", closeLightbox);
lb.addEventListener("click", e => { if(e.target === lb) closeLightbox(); });

/* Eine einzige Escape-Behandlung fuer beide Fenster. Das Bildfenster liegt
   oben, deshalb schliesst Escape zuerst dieses und erst danach das grosse. */
document.addEventListener("keydown", e => {
  if(e.key !== "Escape") return;
  if(lb.classList.contains("on")) closeLightbox();
  else closeModal();
});

/* ---------------- Preistabelle ---------------- */
function tableKey(){ return PRICING[state.product].priceKey.map(k=>state.choices[k]).join("|"); }
function table(){
  const p = PRICING[state.product];
  return p.prices[tableKey()] || Object.values(p.prices)[0];
}
function tierFor(t,q){ let r=null; for(const x of t) if(q>=x.from) r=x; return r; }
function nextTier(t,q){ return t.find(x=>x.from>q) || null; }
function maxTier(t){ return t[t.length-1].from; }

function renderTierChips(){
  const t = table();
  $("tierchips").innerHTML = t.map(x=>
    `<button class="chip" type="button" data-q="${x.from}">${NUM(x.from)}</button>`).join("");
  $("minHint").textContent = `Ab ${NUM(maxTier(t))} Stück offerieren wir individuell.`;
  document.querySelectorAll(".ggc .chip").forEach(c=>
    c.addEventListener("click",()=>{ $("qty").value = c.dataset.q; recalc(); }));
}

/* ---------------- Berechnung ----------------
   Stueckpreis   = Staffelpreis + Summe aller addUnit
   Zwischentotal = Stueckpreis x Menge
   Total         = Zwischentotal + Summe aller surcharge (einmalig)

   Ausgeblendete Gruppen zaehlen nicht mit: wer von A4 gefalzt auf A6 wechselt,
   bezahlt keinen Falz mehr. */
function calc(qtyOverride){
  const p = PRICING[state.product];
  if(p.custom) return { p, custom:true, qty:0, picked:[], surcharge:0,
                        sub:0, total:0, unit:0, allIn:0, img:p.img,
                        tiers:[], tier:null, onRequest:true, belowMin:false };
  const tiers = table();
  const qty = qtyOverride != null ? qtyOverride
            : Math.max(0, parseInt($("qty").value || 0, 10));
  const tier = tierFor(tiers, qty);
  let surcharge = 0, addUnit = 0, img = p.img;
  const picked = [];

  p.options.filter(visible).forEach(o=>{
    const sel = state.choices[o.id];
    const vals = o.type==="radio" ? (sel?[sel]:[]) : sel;
    vals.forEach(v=>{
      const c = o.choices.find(x=>x.v===v);
      if(!c) return;
      surcharge += (c.surcharge || 0);
      addUnit   += (c.addUnit  || 0);
      if(c.img) img = c.img;
      picked.push({group:o.label, label:c.label,
                   surcharge:c.surcharge || 0, addUnit:c.addUnit || 0});
    });
  });

  const onRequest = qty > maxTier(tiers);
  const belowMin  = qty > 0 && qty < tiers[0].from;
  const unit  = (tier ? tier.price : tiers[0].price) + addUnit;
  const sub   = unit * qty;
  const total = sub + surcharge;
  return { p, tiers, qty, tier, unit, surcharge, sub, total, img, picked,
           onRequest, belowMin, allIn: qty>0 ? total/qty : 0 };
}

/* ---------------- UI ---------------- */
function recalc(){
  if(!state.product) return;
  const r = calc(), big = $("pTotal");

  if(r.custom){ renderSummary(r); fillHidden(r); return; }

  if(r.onRequest){
    big.textContent = "Auf Anfrage"; big.classList.add("ask");
    $("pPer").textContent = `Über ${NUM(maxTier(r.tiers))} Stück kalkulieren wir individuell`;
    ["pUnit","pSub","pTotal2"].forEach(id=>$(id).textContent = "–");
    $("kUnit").textContent = "Stückpreis";
    $("mbTotal").textContent = "Auf Anfrage";
  } else {
    big.textContent = CHF(r.total); big.classList.remove("ask");
    $("pPer").textContent    = r.qty>0 ? `${CHF(r.allIn)} pro Stück, alles inklusive` : "–";
    $("pUnit").textContent   = r.qty>0 ? CHF(r.unit) : "–";
    $("kUnit").textContent   = r.tier ? `Stückpreis (ab ${NUM(r.tier.from)} Stk)` : "Stückpreis";
    $("pSub").textContent    = CHF(r.sub);
    $("pTotal2").textContent = CHF(r.total);
    $("mbTotal").textContent = CHF(r.total);
  }
  $("pQty").textContent   = NUM(r.qty) + " Stk";
  $("pSetup").textContent = CHF(r.surcharge);

  const hasS = r.surcharge > 0 && !r.onRequest;
  $("rowSetup").style.display = hasS ? "" : "none";
  $("rowSub").style.display   = hasS ? "" : "none";

  if($("previewImg").src !== r.img) $("previewImg").src = r.img;
  $("previewImg").alt = r.p.name;
  $("previewCaption").textContent =
    r.p.name + " · " + r.picked.map(x=>x.label).join(" · ") + " · " + NUM(r.qty) + " Stk";

  const nudge = $("nudge"), nt = r.onRequest ? null : nextTier(r.tiers, r.qty);
  if(nt && r.qty>0 && !r.belowMin){
    const n = calc(nt.from);
    nudge.classList.add("on");
    nudge.innerHTML = `Noch <strong>${NUM(nt.from - r.qty)} Stück</strong> bis zur nächsten Staffel: `
      + `ab ${NUM(nt.from)} Stk kostet dich das Stück nur noch <strong>${CHF(n.allIn)}</strong> `
      + `statt ${CHF(r.allIn)} — bei einem Total von ${CHF(n.total)}.`;
  } else nudge.classList.remove("on");

  const mw = $("minwarn");
  if(r.belowMin){
    mw.classList.add("on");
    mw.textContent = `Unter der kleinsten Staffel von ${NUM(r.tiers[0].from)} Stück. `
      + `Kleinere Mengen prüfen wir gerne — vermerk es im Bemerkungsfeld.`;
  } else mw.classList.remove("on");

  const aw = $("askwarn");
  if(r.onRequest){
    aw.classList.add("on");
    aw.innerHTML = `Über ${NUM(maxTier(r.tiers))} Stück gibt es keinen Listenpreis mehr — `
      + `bei dieser Menge rechnen wir dir eine <strong>individuelle Offerte</strong>.`;
  } else aw.classList.remove("on");

  renderSummary(r); fillHidden(r);
}

/* Uebersicht im Formular: Raster statt Zeilen ueber die volle Breite. */
function renderSummary(r){
  const dateien = () => {
    const u = $("upload");
    return u && u.files.length ? [...u.files].map(f=>f.name).join(", ") : null;
  };

  if(r.custom){
    const zeilen = [["Anfrage", r.p.name]];
    const d = dateien(); if(d) zeilen.push(["Beilage", d]);
    $("summaryLines").innerHTML =
        `<div class="sgrid">`
      + zeilen.map(([k,v])=>`<div class="scell"><span class="sk">${k}</span><span class="sv">${v}</span></div>`).join("")
      + `</div>`
      + `<div class="stotal"><span class="stk">Beschreib deine Idee unten im Bemerkungsfeld</span>`
      + `<span class="stv">Auf Anfrage</span></div>`;
    return;
  }

  /* Aufpreise stehen direkt bei der Wahl, damit in der Mail nachvollziehbar
     ist, woraus sich der Stueckpreis zusammensetzt. */
  const zusatz = x => x.surcharge ? ` (+${CHF(x.surcharge)} einmalig)`
                    : x.addUnit   ? ` (+${CHF(x.addUnit)} / Stk)` : "";

  const rows = [["Produkt", r.p.name],
    ...r.picked.map(x=>[x.group, x.label + zusatz(x)]),
    ["Auflage", NUM(r.qty) + " Stk"]];
  if(!r.onRequest)    rows.push(["Stückpreis", CHF(r.unit)]);
  if(r.surcharge > 0) rows.push(["Einmaliger Aufpreis", CHF(r.surcharge)]);
  const d = dateien(); if(d) rows.push(["Beilage", d]);

  $("summaryLines").innerHTML =
      `<div class="sgrid">`
    + rows.map(([k,v])=>`<div class="scell"><span class="sk">${k}</span><span class="sv">${v}</span></div>`).join("")
    + `</div>`
    + `<div class="stotal"><span class="stk">Richtpreis, unverbindlich · inkl. MwSt.</span>`
    + `<span class="stv">${r.onRequest ? "Auf Anfrage" : CHF(r.total)}</span></div>`;
}

function fillHidden(r){
  if(r.custom){
    $("h_produkt").value  = r.p.name;
    $("h_optionen").value = "—";
    $("h_menge").value    = "nach Absprache";
    $("h_preis").value    = "Auf Anfrage — freie Anfrage ohne Konfigurator";
    $("h_subject").value  = "Custom-Anfrage: eigene Idee";
    return;
  }
  $("h_produkt").value  = r.p.name;
  $("h_optionen").value = r.picked.map(x=>`${x.group}: ${x.label}`).join(" | ");
  $("h_menge").value    = NUM(r.qty) + " Stk";
  $("h_preis").value    = r.onRequest
    ? `Über ${NUM(maxTier(r.tiers))} Stk – individuelle Kalkulation nötig`
    : `${CHF(r.unit)}/Stk` + (r.surcharge ? ` + ${CHF(r.surcharge)} einmalig` : "")
      + ` = ${CHF(r.total)} inkl. MwSt. (Richtwert aus dem Konfigurator)`;
  $("h_subject").value  = `Custom-Anfrage: ${r.p.name}, ${NUM(r.qty)} Stk`;
}

/* ---------------- Preisliste ---------------- */
function openPriceSheet(){
  if(!state.product) return;
  const p = PRICING[state.product];
  if(p.custom) return;            // ohne Preisliste gibt es nichts zu drucken

  if(p.pdf){ window.open(p.pdf, "_blank", "noopener"); return; }

  const labelFor = key => {
    if(!key) return "";
    return p.priceKey.map((id,i)=>{
      const o = p.options.find(x=>x.id===id);
      const c = o.choices.find(x=>x.v===key.split("|")[i]);
      return c ? c.label : "";
    }).join(" · ");
  };

  const tabellen = Object.entries(p.prices).map(([key,tiers])=>{
    const titel = labelFor(key);
    return (titel ? `<h2>${titel}</h2>` : "")
      + `<table><thead><tr><th>Auflage</th><th>Preis pro Stück</th></tr></thead><tbody>`
      + tiers.map(t=>`<tr><td>ab ${NUM(t.from)} Stück</td><td>${CHF(t.price)}</td></tr>`).join("")
      + `<tr class="req"><td>über ${NUM(maxTier(tiers))} Stück</td><td>auf Anfrage</td></tr>`
      + `</tbody></table>`;
  }).join("");

  const zusatz = [];
  p.options.forEach(o => o.choices.forEach(c => {
    if(c.addUnit)   zusatz.push([`${o.label}: ${c.label}`, `+ ${CHF(c.addUnit)} pro Stück`]);
    if(c.surcharge) zusatz.push([`${o.label}: ${c.label}`, `+ ${CHF(c.surcharge)} einmalig`]);
  }));

  const doc = `<!DOCTYPE html><html lang="de-CH"><head><meta charset="utf-8">
<title>Preisliste 2026 — ${p.name} — Gorilla Gardening</title>
<style>
  *{box-sizing:border-box}
  body{margin:0;padding:48px 56px;font-family:"Jost","Century Gothic",Futura,
       -apple-system,"Segoe UI",Helvetica,Arial,sans-serif;font-weight:300;
       color:#1e4e1c;line-height:1.6;max-width:820px}
  .eyebrow{font-size:11px;letter-spacing:.2em;text-transform:uppercase;color:#3a8437}
  h1{font-size:32px;font-weight:400;margin:10px 0 4px;letter-spacing:-.01em}
  .sub{color:#6d7b6c;font-size:16px;margin:0 0 36px}
  h2{font-size:13px;letter-spacing:.14em;text-transform:uppercase;color:#6d7b6c;
     font-weight:500;margin:32px 0 10px}
  table{width:100%;border-collapse:collapse;margin-bottom:10px}
  th{text-align:left;font-size:12px;letter-spacing:.08em;text-transform:uppercase;
     color:#6d7b6c;font-weight:500;padding:0 0 9px;border-bottom:1px solid #1e4e1c}
  th:last-child,td:last-child{text-align:right}
  td{padding:11px 0;border-bottom:1px solid #eceee9;font-size:16px;
     font-variant-numeric:tabular-nums}
  tr.req td{color:#6d7b6c}
  .specs{margin-top:34px;padding-top:22px;border-top:1px solid #eceee9;
         font-size:14.5px;color:#6d7b6c;line-height:1.65}
  .specs strong{font-weight:500;color:#1e4e1c}
  .foot{margin-top:38px;padding-top:20px;border-top:1px solid #eceee9;
        font-size:13px;color:#6d7b6c}
  .noprint{margin-top:32px}
  button{font:inherit;font-size:13px;letter-spacing:.1em;text-transform:uppercase;
         background:#1e4e1c;color:#fff;border:0;padding:14px 26px;border-radius:3px;
         cursor:pointer}
  @media print{ .noprint{display:none} body{padding:0} }
</style></head><body>
  <div class="eyebrow">Preisliste 2026</div>
  <h1>${p.name}</h1>
  <p class="sub">${p.desc}</p>
  ${tabellen}
  ${zusatz.length ? `<h2>Zuschläge</h2><table><tbody>`
    + zusatz.map(([a,b])=>`<tr><td>${a}</td><td>${b}</td></tr>`).join("")
    + `</tbody></table>` : ""}
  ${p.specs ? `<div class="specs">${p.specs}</div>` : ""}
  <div class="foot">
    Alle Preise pro Stück und inkl. MwSt., exkl. Versand. Unverbindlich, kein Angebot.<br>
    Gorilla Gardening · re:gardening gmbh · Gurtenweg 11, 3084 Wabern ·
    031 558 50 22 · info@gorilla-gardening.ch
  </div>
  <div class="noprint"><button onclick="window.print()">Als PDF speichern</button></div>
</body></html>`;

  // Bewusst OHNE "noopener": das Flag kappt die Verbindung zum neuen Fenster,
  // dann liesse es sich nicht mehr befuellen und bliebe leer.
  const w = window.open("", "_blank");
  if(!w){ alert("Bitte erlaube Pop-ups, damit sich die Preisliste öffnen kann."); return; }
  w.document.open();
  w.document.write(doc);
  w.document.close();
}
$("pdfBtn").addEventListener("click", openPriceSheet);

/* ---------------- Dateiauswahl ----------------
   Formspree-Grenzen laut Doku: max. 10 Dateien je Einsendung, je 25 MB,
   Request gesamt 100 MB, 30 s Timeout. Wir bleiben bewusst darunter. */
const MAX_FILES = 3, MAX_MB = 25;
const up = $("upload"), dropL = $("dropLabel");

function fileError(){
  const fs = [...up.files];
  if(fs.length > MAX_FILES) return `Bitte höchstens ${MAX_FILES} Dateien wählen.`;
  const big = fs.find(f => f.size > MAX_MB*1024*1024);
  if(big) return `„${big.name}" ist grösser als ${MAX_MB} MB.`;
  return null;
}

function showFiles(){
  const fs = [...up.files], err = fileError();
  $("filelist").innerHTML = fs.map(f=>{
    const mb  = f.size/1024/1024;
    const bad = mb > MAX_MB || fs.length > MAX_FILES;
    return `<div class="f${bad?" bad":""}"><span>${f.name}</span>`
         + `<span class="sz">${mb < 0.1 ? "<0.1" : mb.toFixed(1)} MB</span></div>`;
  }).join("") + (err ? `<div class="f bad"><span>${err}</span></div>` : "");
  dropL.querySelector(".drop-main").textContent =
    fs.length ? (fs.length===1 ? "1 Datei gewählt — ändern" : fs.length+" Dateien gewählt — ändern")
              : "Datei wählen oder hierhin ziehen";
  if(state.product) renderSummary(calc());
}
up.addEventListener("change", showFiles);

["dragenter","dragover"].forEach(e=>dropL.addEventListener(e, ev=>{
  ev.preventDefault(); dropL.classList.add("over"); }));
["dragleave","drop"].forEach(e=>dropL.addEventListener(e, ev=>{
  ev.preventDefault(); dropL.classList.remove("over"); }));
dropL.addEventListener("drop", ev=>{
  if(ev.dataTransfer.files.length){ up.files = ev.dataTransfer.files; showFiles(); }
});

/* ---------------- Absenden (nur Anfrage, kein Kauf) ---------------- */
$("offerteForm").addEventListener("submit", async e=>{
  e.preventDefault();
  const st = $("formstate");
  st.className = "formstate";

  if(!$("name").value.trim() || !$("email").value.trim() || !$("dsg").checked){
    st.className = "formstate err";
    st.textContent = "Bitte Name, E-Mail und die Einwilligung ausfüllen.";
    return;
  }
  const ferr = fileError();
  if(ferr){ st.className = "formstate err"; st.textContent = ferr; return; }

  if(!FORMSPREE_ENDPOINT || FORMSPREE_ENDPOINT.indexOf("formspree.io/f/") === -1){
    st.className = "formstate err";
    st.textContent = "Es ist kein gültiger Formspree-Endpoint hinterlegt. "
      + "Im Theme-Editor unter den Einstellungen dieser Section eintragen.";
    return;
  }

  $("h_replyto").value = $("email").value.trim();   // Antwort geht an den Kunden
  const fd = new FormData(e.target);

  const btn = $("submitBtn");
  btn.disabled = true; btn.textContent = "Wird gesendet …";
  try{
    const res = await fetch(FORMSPREE_ENDPOINT,
      { method:"POST", body:fd, headers:{ Accept:"application/json" } });
    if(res.ok){
      e.target.reset(); showFiles();
      st.className = "formstate ok";
      st.innerHTML = "<strong>Danke, deine Anfrage ist bei uns.</strong><br>"
        + "Wir melden uns innerhalb von zwei Arbeitstagen mit einer persönlichen Offerte.";
    } else {
      const d = await res.json().catch(()=>({}));
      throw new Error(d.errors ? d.errors.map(x=>x.message).join(", ") : "Fehler "+res.status);
    }
  }catch(err){
    st.className = "formstate err";
    st.innerHTML = "Das hat leider nicht geklappt: " + err.message
      + "<br>Schreib uns direkt an <a href='mailto:info@gorilla-gardening.ch'>info@gorilla-gardening.ch</a>.";
  }finally{
    btn.disabled = false; btn.textContent = "Unverbindliche Offerte anfordern";
  }
});

$("qty").addEventListener("input", recalc);
$("toForm").addEventListener("click", ()=>$("offerteSection").scrollIntoView({behavior:"smooth"}));
$("mbBtn").addEventListener("click",  ()=>$("offerteSection").scrollIntoView({behavior:"smooth"}));
$("resetBtn").addEventListener("click",()=>selectProduct(state.product, false));

/* Start: nur Titel und Produktwahl – der Rest erscheint nach der Auswahl */
renderProducts();

})();
